import BaseFormPresenter from "../../../../../components/common/BaseFormPresenter";
import SearchSelect from "../../../../../components/searchSelect/SearchSelect";
import FindObjectUseCase from "../../../../../usecases/object/FindObjectUseCase";

class EmploymentPresenter extends BaseFormPresenter {
  constructor(view) {
    super(view);
    this.view = view;
  }

  findObjectUseCase() {
    return new FindObjectUseCase();
  }

  async onChange(value, field) {
    this.change[field] = value;
    this.object[field] = value;
    this.view.setObject(this.object);
    // this.findObjectUseCase().abort();

    if (field === "designations") {
      let ids = [];
      for (const item of value) {
        ids.push(item.id);
      }

      const designations = await this.findObjectUseCase().execute(
        "nature_functions",
        {
          keys: ["payCode"],
          where: {
            id: { $in: ids },
          },
          include: ["payCode"],
        },
      );

      console.log("designations", designations);

      const maxAmount = designations.length
        ? Math.max(
            ...designations.map((item) => {
              const amountStr = item?.payCode?.amount || "₱ 0";
              return Number(amountStr.replace(/[^0-9.]/g, ""));
            }),
          )
        : 0;

      const object = {
        payCode: maxAmount,
      };
      this.view.setObject(object);
    }

    if (field === "nonRegPosition") {
      const nonRegPosition = await this.findObjectUseCase().execute(
        "non_plantilla",
        {
          where: {
            id: value?.id,
          },
        },
      );

      const item = nonRegPosition[0];

      if (item?.isTwoPercent || item?.isFivePercent) {
        const object = {
          percentTag: item.isTwoPercent
            ? "2%"
            : item.isFivePercent
              ? "5%"
              : null,
        };
        this.view.setObject(object);
      }
    }

    // if (field === "position") {
    //   const type = {
    //     regOrnonReg: value?.position_title,
    //     ...(this.view.props.object?.nonRegPosition && {
    //       nonRegPosition: { id: "" },
    //     }),
    //   };
    //   this.view.setObject(type);
    // } else if (field === "nonRegPosition") {
    //   const type = {
    //     regOrnonReg: value?.positionTitle,
    //     ...(this.view.props.object?.position && { position: { id: "" } }),
    //   };
    //   this.view.setObject(type);
    // }
  }

  // SearchSelectItem(className, style, label, value, onChange, option) {
  //   const isRequiredField =
  //     label === "24 / 7" ||
  //     label === "Graduated or Not?" ||
  //     label === "Is Annex B2 submitted?";
  //   return (
  //     <div className={className} style={style}>
  //       <label style={{ fontSize: "14px", paddingBottom: "10px" }}>
  //         {label === "Regions" ||
  //         label === "Offices" ||
  //         label === "Division" ||
  //         label === "Section" ||
  //         label === "Unit" ||
  //         label === "Cluster" ? (
  //           <span>
  //             {label === "Cluster" ? "Plantilla" : label}
  //             <span style={{ color: "red" }}> *</span>
  //           </span>
  //         ) : (
  //           label
  //         )}
  //       </label>
  //       <label style={{ fontSize: "14px", paddingBottom: "10px" }}>
  //         {isRequiredField && (
  //           <span style={{ color: "red", marginLeft: "5px" }}> *</span>
  //         )}
  //       </label>
  //       <SearchSelect
  //         required={isRequiredField} // Pass `required` prop if needed by the SearchSelect
  //         value={value}
  //         onChange={onChange}
  //         options={option.map((type) => ({
  //           label: type.name,
  //           value: type.name,
  //         }))}
  //       />
  //     </div>
  //   );
  // }

  updateDailyRate(salaryGrade) {
    const monthlyRateString = salaryGrade;
    const monthlyRateMatch = monthlyRateString.match(/₱\s*([\d,.]+)/);

    if (monthlyRateMatch) {
      const monthlyRate = parseFloat(monthlyRateMatch[1].replace(/,/g, ""));
      const dailyRate = (monthlyRate * 12) / 261;
      const formattedDailyRate = dailyRate.toFixed(2);

      const hourlyRate = formattedDailyRate / 8;
      const formattedHourlyRate = hourlyRate.toFixed(2);

      this.view.setState({
        dailyRate: formattedDailyRate,
        hourlyRate: formattedHourlyRate,
      });
    } else {
      console.error("Monthly rate not found in the salaryGrade string.");
    }
  }

  calculateTenure(dateHired) {
    const hireDate = new Date(dateHired);
    const currentDate = new Date();

    let years = currentDate.getFullYear() - hireDate.getFullYear();
    let months = currentDate.getMonth() - hireDate.getMonth();
    let days = currentDate.getDate() - hireDate.getDate();

    if (months < 0) {
      years--;
      months += 12;
    }

    if (days < 0) {
      months--;
      const prevMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        0,
      );
      days += prevMonth.getDate();
    }

    return { years, months, days };
  }

  // getLastNonEmptyField(source) {
  //   let result;
  //   let index;
  //   this.view.state.fields.forEach((field, i) => {
  //     if (source[field] && source[field] !== "") {
  //       result = source[field];
  //       index = i;
  //     }
  //   });

  //   return { result, index };
  // }

  formatTenure({ years, months, days }) {
    let result = "";

    if (years > 0) {
      result += `${years} year${years > 1 ? "s" : ""}`;
    }

    if (months > 0) {
      if (result) result += ", ";
      result += `${months} month${months > 1 ? "s" : ""}`;
    }

    if (days > 0) {
      if (result) result += ", ";
      result += `${days} day${days > 1 ? "s" : ""}`;
    }

    return result || "0 days";
  }

  async handleNext() {
    const object = this.view.props.object;
    const diff = this.calculateTenure(object.hired);
    const result = this.formatTenure(diff);

    this.view.onChange(result, "lengthOfService");
    this.view.setState((prevState) => ({
      isShown: object.employmentType === "Job Order" || prevState.isShown,
    }));
    // if (!object.selectedSchedule) {
    //   // const org = this.getLastNonEmptyField(object);

    //   // const field = this.view.state.fields[org.index];

    //   const scheduleTemplate = await this.findObjectUseCase().execute(
    //     "schedule_template",
    //     // { where: { [field]: org.result } },
    //     {
    //       where: {
    //         $or: [
    //           { regions: object?.region },
    //           { offices: object?.office },
    //           { divisions: object?.division },
    //           { sections: object?.section },
    //           { units: object?.unit },
    //           { plantilla: object?.cluster },
    //           // { selectAll: true },
    //         ],
    //       },
    //     },
    //   );

    //   if (scheduleTemplate.length > 0) {
    //     const sched = { selectedSchedule: scheduleTemplate[0] };
    //     this.view.setObject(sched);
    //   }
    // }

    const query = {
      where: {
        empID: this.view.props.object.id,
      },
    };

    const employees = await this.findObjectUseCase().execute(
      "allowances",
      query,
    );

    const employeeAllowance = {
      allowance: employees,
    };
    this.view.setObject(employeeAllowance);

    const queryAgency = {
      where: {
        agency: object.agency,
        id: { $ne: object.id },
      },
    };

    const checkAgencyExists = await this.findObjectUseCase().execute(
      "employees",
      queryAgency,
    );

    console.log("checkAgencyExists", checkAgencyExists);

    if (checkAgencyExists?.length > 0) {
      this.view.showError("Agency exists.");
      return;
    }
    this.view.props.onChangeTab();
  }
}
export default EmploymentPresenter;
